import React from 'react';
import './Hero.css';

export default function Hero() {
  const heroImage = '/Personalphoto2.jpg';

  return (
    <section className="hero" id="top">
      <div className="hero__bg" aria-hidden />
      <div className="container hero__inner">
        <div className="hero__content">
          <div className="hero__eyebrow">Results Driven Project Management & IT Services</div>
          <h1 className="hero__title">
            Ship on time.
            <span className="hero__titleAccent"> Keep systems stable.</span>
            <span className="hero__titleAccent"> Scale with confidence.</span>
          </h1>
          <p className="hero__subtitle">
            I help startups, SMEs, and enterprise teams deliver technology initiatives reliably and
            keep IT environments running whilst reducing delays, downtime, and delivery risk.
          </p>

          <div className="hero__ctaRow">
            <a className="hero__ctaPrimary" href="#work-with-me">
              Request a Consultation
            </a>
            <a className="hero__ctaSecondary" href="#services">
              View Services
            </a>
          </div>

          <dl className="hero__highlights" aria-label="Highlights">
            <div className="hero__highlight">
              <dt>7+ years</dt>
              <dd>Banking, FinTech, IT services</dd>
            </div>
            <div className="hero__highlight">
              <dt>PMP® + ITIL</dt>
              <dd>Delivery + service management</dd>
            </div>
            <div className="hero__highlight">
              <dt>Agile</dt>
              <dd>Scrum leadership & execution</dd>
            </div>
          </dl>
        </div>

        <div className="hero__media" aria-label="Profile image">
          <div className="hero__mediaFrame">
            <img className="hero__image" src={heroImage} alt="Emmanuel Obeng" loading="eager" />
          </div>
        </div>
      </div>
    </section>
  );
}
